import { Button, Center, Stack, Text, Title } from "@mantine/core";
import { Link } from "react-router-dom";

export function NotFoundPage() {
  return (
    <Center h="70vh">
      <Stack align="center" gap="md">
        <Title order={1}>404</Title>
        <Text c="dimmed">That page doesn’t exist.</Text>
        <Button component={Link} to="/sites">
          Back to sites
        </Button>
      </Stack>
    </Center>
  );
}
